import { render, staticRenderFns } from "./ReferralBonusSettings.vue?vue&type=template&id=1867aa86&"
import script from "./ReferralBonusSettings.vue?vue&type=script&lang=js&"
export * from "./ReferralBonusSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports